import { useParams } from 'react-router-dom';
import { useEffect, useState,useContext } from 'react';
import axios from 'axios';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { AuthContext } from "./../../AuthContext/AuthContext";
import { BASE_URL } from './../../Api/ApiUrls';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Card,
  CardContent,
  Divider,
  List,
  ListItem,
  ListItemText,
  CircularProgress
} from '@mui/material';
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';

function WishlistUsersPage() {
  const { propertyId } = useParams();
    const { userId } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
const [alertMessage, setAlertMessage] = useState("");
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
  // useEffect(() => {
  //   const fetchWishlistUsers = async () => {
  //     try {
  //       const response = await axios.get(`${BASE_URL}/user-cart/`);
  //       const filteredUsers = response.data.filter(
  //         item => item.property_id == propertyId
  //       );
        
  //       const usersWithDetails = await Promise.all(
  //         filteredUsers.map(async (cartItem) => {
  //           const userResponse = await axios.get(`${BASE_URL}/users/${cartItem.user_id}/`);
  //           return {
  //             ...cartItem,
  //             userDetails: userResponse.data
  //           };
  //         })
  //       );
        
  //       setUsers(usersWithDetails);
  //     } catch (error) {
  //       console.error('Error fetching wishlist users:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchWishlistUsers();
  // }, [propertyId]);


  useEffect(() => {
  const fetchWishlistUsers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user-cart/`);

      // Step 1: Filter property and remove logged-in user
      const filteredUsers = response.data.filter(
        (item) =>
          item.property_id == propertyId &&
          item.user_id !== userId
      );

      // Step 2: Remove duplicate users
      const uniqueUsers = [
        ...new Map(filteredUsers.map(item => [item.user_id, item])).values()
      ];

      // Step 3: Fetch user details
      const usersWithDetails = await Promise.all(
        uniqueUsers.map(async (cartItem) => {
          const userResponse = await axios.get(
            `${BASE_URL}/users/${cartItem.user_id}/`
          );

          return {
            ...cartItem,
            userDetails: userResponse.data,
          };
        })
      );

      setUsers(usersWithDetails);

    } catch (error) {
      console.error("Error fetching wishlist users:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchWishlistUsers();
}, [propertyId, userId]);
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

return (
  
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url('/constructin4.png')
      `,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
     overflow: 'auto'
    }}>
      {/* Fixed Header */}
      <AppBar 
        position="fixed" 
        elevation={0}
          sx={{ 
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1200, // Added zIndex
          background: `
            linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
            url('/construction4.png')
          `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton 
            edge="start" 
            onClick={() => navigate(-1)}
            sx={{ 
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': { 
                backgroundColor: 'rgba(255,255,255,0.2)' 
              }
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white' }}>
           Added propertyId {propertyId} to wishlist
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Spacer to push content below fixed header */}
      <Toolbar sx={{ minHeight: 64 }} />

      {/* Main Content - Scrollable Area */}
   <Container 
  sx={{ 
    py: 3,
    mb: "80px",
    height: "calc(100vh - 144px)",
    overflowY: "auto"
  }}
>
        <Card sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: 3 }}>
         <Typography
  variant="h5"
  align="center"
  sx={{ p: 1, backgroundColor: '#f5f5f5', fontWeight: 'bold' }}
>
  Wishlist Users
</Typography>

          <CardContent>
           {users.length > 0 ? (
                <Box display="flex" flexDirection="column" gap={2}>
                  {users.map((userCart) => (
                    <Card
                      key={userCart.cart_id}
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        boxShadow: 2,
                        backgroundColor: '#fff',
                      }}
                    >
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                          {userCart.userDetails?.username || "Unknown User"}
                        </Typography>
                        <Box
                          sx={{
                            backgroundColor: '#d4f3ef',
                            color: '#00695f',
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 2,
                            fontSize: '12px',
                            fontWeight: 500
                          }}
                        >
                          Excellent match
                        </Box>
                      </Box>

                      {/* <Typography variant="body2" mt={1}>
                        <strong>Budget:</strong> 1.5L to 1.5cr
                      </Typography> */}
                      <Typography variant="body2">
                        <strong>Address:</strong> {userCart.userDetails?.city || "Unknown User"} {userCart.userDetails?.state || "Unknown User"} 
                      </Typography>
                      <Typography variant="body2">
                        <strong>Last Active On:</strong> {new Date(userCart.created_at).toLocaleDateString()}
                      </Typography>
                      {/* <Typography variant="body2" mb={2}>
                        <strong>Properties Contacted:</strong> 05
                      </Typography> */}

                      <Box textAlign="center">
                     <Box
    onClick={() => {
      const phone = userCart.userDetails?.mobile_no || "N/A";

      navigator.clipboard.writeText(phone)
        .then(() => {
          setAlertMessage(`Phone number ${phone} copied successfully`);
          setShowSuccess(true);
        })
        .catch(() => {
          setAlertMessage("Failed to copy phone number");
          setShowFailure(true);
        });
    }}
                          sx={{
                            backgroundColor: '#e53935',
                            color: '#fff',
                            py: 1,
                            marginTop: 2,
                            borderRadius: '20px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: '#d32f2f',
                            },
                          }}
                        >
                          📞 {userCart.userDetails?.mobile_no || "N/A"} (Tap to Copy)
                        </Box>
                      </Box>
                    </Card>
                  ))}
                </Box>
              ) : (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography variant="h6" color="text.secondary">
                    No users have added this property to their wishlist yet
                  </Typography>
                </Box>
              )}

          </CardContent>
        </Card>
      </Container>

{showSuccess && (
  <CopySuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowSuccess(false);
      setAlertMessage("");
    }}
  />
)}

{showFailure && (
  <CopyFailureAlert
    message={alertMessage}
    onClose={() => {
      setShowFailure(false);
      setAlertMessage("");
    }}
  />
)}
      {/* Bottom Navigation */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar /> 
      </Box>
    </Box>
  );
}

export default WishlistUsersPage;



